const STORAGE_KEY_COUNTRY = "poff.locale.country";
const STORAGE_KEY_LANGUAGE = "poff.locale.language";

export function readStoredCountry(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY_COUNTRY);
  } catch {
    return null;
  }
}

export function readStoredLanguage(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY_LANGUAGE);
  } catch {
    return null;
  }
}

export function storeCountry(country: string): void {
  try {
    localStorage.setItem(STORAGE_KEY_COUNTRY, country);
  } catch {
    // storage unavailable (e.g. SSR, private browsing quota exceeded)
  }
}

export function storeLanguage(language: string): void {
  try {
    localStorage.setItem(STORAGE_KEY_LANGUAGE, language);
  } catch {
    // storage unavailable
  }
}
